import { useAppState } from "../context/StateContext";
import { getTimezoneFromUserOrBrowser } from "../util/getBrowserTimezone";

export const useTimezoneForJob = () => {
  const { currentUser } = useAppState();

  const getTimezone = (): string => {
    return getTimezoneFromUserOrBrowser(currentUser);
  };

  return { getTimezone };
};
